import { combineReducers } from "redux";
import workReducer from "./work/work.reducer";
import techReducer from "./techs/tech.reducer";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import poemsReducer from "./poems/poems.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["capabilities"],
};

const rootReducer = combineReducers({
  work: workReducer,
  poems: poemsReducer,
  capabilities: techReducer,
});

export default persistReducer(persistConfig, rootReducer);
